import { render, staticRenderFns } from "./KoutsuhiPatternCard.vue?vue&type=template&id=202ea2f4&scoped=true&"
import script from "./KoutsuhiPatternCard.vue?vue&type=script&lang=ts&"
export * from "./KoutsuhiPatternCard.vue?vue&type=script&lang=ts&"
import style0 from "./KoutsuhiPatternCard.vue?vue&type=style&index=0&id=202ea2f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202ea2f4",
  null
  
)

export default component.exports